import PropTypes from 'prop-types';
import { useState } from 'react';
import Button from '../atoms/Button';
import InputBox from '../atoms/InputBox';
import Text from '../atoms/Text';
import Message from '../molecules/Message';

const OtpVerification = ({
    email,
    setOTP,
    isOTPError,
    setIsOTPError,
    handleResend,
    isLoading,
    ...property
}) => {
    const [showResendMessage, setShowResendMessage] = useState(false);

    const handleResendMessage = () => {
        setShowResendMessage(true);
        setTimeout(() => {
            setShowResendMessage(false);
        }, 5000);
    };

    return (
        <div
            className={`flex flex-col space-y-4 md:space-y-6 mt-4 md:mt-8 mb-6 ${property.className}`}
        >
            {showResendMessage ? (
                <Message
                    padding="px-4 py-1"
                    bgColor="bg-primary-50"
                    textColor="text-success-100"
                >
                    {`OTP has been sent to - ${email}`}
                </Message>
            ) : (
                <Message
                    padding="px-4 py-3"
                    bgColor="bg-primary-50"
                    textColor="text-success-100"
                >
                    {`We have sent a verification code to your email - ${email}`}
                </Message>
            )}

            <div className='flex flex-col space-y-6'>
                <InputBox
                    isError={isOTPError}
                    type="number"
                    placeholder="Verification Code"
                    variant="Large"
                    errorMessage="OTP entered is incorrect. Please enter a valid OTP to continue!"
                    className="otp-input"
                    onChange={(e) => {
                        setIsOTPError(false);
                        setOTP(e.target.value);
                    }}
                />
                <Button
                    type="submit"
                    label="Verify"
                    size="medium"
                    disabled={isLoading}
                />

                <Text
                    variant="body"
                    className="text-center text-secondary-400"
                    fontWeight="font-medium"
                >
                    Didn't receive the OTP?
                    <span
                        onClick={() => {
                            handleResend();
                            handleResendMessage();
                        }}
                        className="text-primary-900 cursor-pointer hover:text-primary-800 font-medium ml-3"
                    >
                        Resend
                    </span>
                </Text>
            </div>
        </div>
    );
};

OtpVerification.propTypes = {
    email: PropTypes.string
};

export default OtpVerification;
